<template>
  <navbar
    v-model="showNavbar"
    type="default"
  >
    <div class="navbar-wrapper">
      <div class="navbar-toggle">
        <navbar-toggle-button @click.native="toggleSidebar" />
      </div>
      <a
        class="navbar-brand"
        href="#"
      >{{ routeName }}</a>
      <p-button
        v-if="this.$route.meta.editPath && this.$root.isAdmin"
        type="info"
        class="d-none d-md-block"
        link
        size="sm"
        @click="edit"
      >
        edit
      </p-button>
    </div>
    <template slot="navbar-menu">
      <ul class="navbar-nav">
        <drop-down
          icon="nc-icon nc-bell-55"
          tag="li"
          position="right"
          direction="none"
          class="nav-item btn-rotate dropdown"
        >
          <a
            slot="title"
            slot-scope="{isOpen}"
            class="nav-link dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            :aria-expanded="isOpen"
          >
            <p>
              <span>{{ $root.courseName }}</span>
            </p>
          </a>
          <a
            class="dropdown-item"
            style="cursor:pointer"
            v-for="c in this.$root.courses"
            :key="c.CourseKey"
            @click="switchCourses(c.CourseKey)"
          >{{ c.CourseName }}</a>
          <a
            class="dropdown-divider"
            href="#"
          >
            <hr class="m-0">
          </a>
          <a
            class="dropdown-item"
            href="#"
            @click="acceptInvitation"
          >Accept Invitation</a>
          <a
            class="dropdown-item"
            href="#"
            @click="createCourse"
          >Create Course</a>
        </drop-down>
        <drop-down
          icon="nc-icon nc-bell-55"
          tag="li"
          position="right"
          direction="none"
          class="nav-item btn-rotate dropdown"
        >
          <a
            slot="title"
            slot-scope="{isOpen}"
            class="nav-link dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            :aria-expanded="isOpen"
          >
            <i class="ti-user" /> {{ $root.userFullName }}
            <p>
              <span class="d-lg-none d-md-block">{{ $root.userFullName }}</span>
            </p>
          </a>
          <a
            class="dropdown-item"
            href="#"
            @click="changePassword"
          >Change Password</a>
          <a
            class="dropdown-item"
            href="#"
            @click="logout"
          >Sign Out</a>
        </drop-down>
      </ul>
    </template>
  </navbar>
</template>

<script>
import security from '@/services/security.js'
import { Navbar, NavbarToggleButton } from '@/plugins/paper-components'

export default {
  components: {
    Navbar,
    NavbarToggleButton
  },
  data: function () {
    return {
      activeNotifications: false,
      showNavbar: false
    }
  },
  computed: {
    routeName: function () {
      const { name } = this.$route
      return this.capitalizeFirstLetter(name)
    }
  },
  methods: {
    edit: function () {
      this.showNavbar = false
      this.$router.push(this.$route.meta.editPath)
    },
    capitalizeFirstLetter: function (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    toggleNotificationDropDown: function () {
      this.activeNotifications = !this.activeNotifications
    },
    closeDropDown: function () {
      this.activeNotifications = false
    },
    toggleSidebar: function () {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    hideSidebar: function () {
      this.$sidebar.displaySidebar(false)
    },
    minimizeSidebar: function () {
      this.$sidebar.toggleMinimize()
    },
    toggleNavbar: function () {
      this.showNavbar = !this.showNavbar
    },
    logout: function () {
      security.teardownVueSession(this.$root)
      this.showNavbar = false
      this.$router.push('/login')
    },
    login: function () {
      if (this.$route.path !== '/login') {
        this.showNavbar = false
        this.$router.push('/login')
      }
    },
    changePassword: function () {
      this.$router.push('/change-password')
    },
    switchCourses: function (courseKey) {
      if (courseKey !== this.$root.courseKey) {
        security.setupCourse(this.$root, courseKey)
        this.showNavbar = false
        if (
          this.$root.courseScouterType === 'Participant' &&
          this.$route.path !== '/participant/welcome'
        ) {
          this.$router.push('/participant/welcome')
        } else if (
          this.$root.courseScouterType === 'Staff' &&
          this.$route.path.includes('edit') &&
          !this.$root.isAdmin
        ) {
          this.$router.push('/staff/dashboard')
        }
        this.$root.$emit('course-change', courseKey)
      }
    },
    createCourse: function () {
      this.$router.push('/create-course')
    },
    acceptInvitation: function () {
      this.$router.push('/invitation')
    }
  }
}
</script>
<style scoped>
  .navbar .navbar-nav .nav-item.active .nav-link:not(.btn),
  .navbar .navbar-nav .nav-item .nav-link:not(.btn):focus,
  .navbar .navbar-nav .nav-item .nav-link:not(.btn):hover,
  .navbar .navbar-nav .nav-item .nav-link:not(.btn):active {
    color: #51bcda;
  }
</style>
